import { register } from '@shopify/theme-sections';
import 'simplebar';
import 'simplebar/dist/simplebar.css';

register('gallery-list', {
    onLoad() {
        
    }
});